import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The add form is a modal on the list now (CAE-1598), not a screen of its own.
 * Redirecting rather than deleting keeps a bookmarked `/new` doing what it
 * always did — opening an empty tier editor — and `?tier=new` is where that
 * lives.
 */
export const Route = createFileRoute('/prize-tier-defaults/new')({
  beforeLoad: () => {
    throw redirect({ to: '/prize-tier-defaults', search: { tier: 'new' }, replace: true });
  },
});
